var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showErrors)?_c('div',_vm._l((_vm.errors),function(error){return _c('div',{staticClass:"error-message"},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }